import { createApp } from 'vue';
import App from '@app/App.vue';

import '@shared/styles/_conf.scss';
import store from '@shared/store/index.js';
import router from '@shared/routers/index.js';

import { loadYandexMetrika } from '@shared/libraries/yandexMetrika/yandexMetrika';
import { PROJECT_KEYS } from '@shared/constants/keys/keys';

const app = createApp(App);

app.use(store);
app.use(router);

loadYandexMetrika(PROJECT_KEYS.YANDEX_METRIKA_KEY);

app.mount('#app');